import { RelatedTermTypes } from '../shared/components/styled/search/types';
import { Entity, EntityType, TermRelationshipType } from '../../../types.generated';
import EntityRegistry from '../EntityRegistry';

const ASSOCIATED_WITH = 'associatedWithGlossary';
const UTILIZED_BY = 'utilizedBy';

export function sortGlossaryTerms(entityRegistry: EntityRegistry, nodeA?: Entity | null, nodeB?: Entity | null) {
    const nodeAName = entityRegistry.getDisplayName(EntityType.GlossaryTerm, nodeA) || '';
    const nodeBName = entityRegistry.getDisplayName(EntityType.GlossaryTerm, nodeB) || '';
    return nodeAName.localeCompare(nodeBName);
}

export function getRelatedEntitiesUrl(entityRegistry: EntityRegistry, urn: string) {
    return `${entityRegistry.getEntityUrl(EntityType.GlossaryTerm, urn)}/${encodeURIComponent('Related Entities')}`;
}

export function isInverseRelationship(relationshipType: RelatedTermTypes) {
    const inverseRelationships = [
        RelatedTermTypes.isTypeOf,
        RelatedTermTypes.isAChildren,
        RelatedTermTypes.hasAssociationTerms,
        RelatedTermTypes.utilizedInTerms,
        RelatedTermTypes.containedBy,
    ];

    return inverseRelationships.includes(relationshipType);
}

export function getRelationshipType(relationshipType = '') {
    const relationshipMapping = {
        // Direct relationships
        [RelatedTermTypes.typeOfRelations]: RelatedTermTypes.typeOfRelations,
        [RelatedTermTypes.associatedWithTerms]: ASSOCIATED_WITH,
        [RelatedTermTypes.utilizedByTerms]: UTILIZED_BY,
        [RelatedTermTypes.hasRelatedTerms]: TermRelationshipType.HasA,
        [RelatedTermTypes.isRelatedTerms]: TermRelationshipType.IsA,
        // Inverse relationships
        [RelatedTermTypes.isTypeOf]: RelatedTermTypes.typeOfRelations,
        [RelatedTermTypes.isAChildren]: TermRelationshipType.IsA,
        [RelatedTermTypes.hasAssociationTerms]: ASSOCIATED_WITH,
        [RelatedTermTypes.utilizedInTerms]: UTILIZED_BY,
        [RelatedTermTypes.containedBy]: TermRelationshipType.HasA,
    };

    return relationshipMapping[relationshipType] ?? relationshipType;
}
